import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faEnvelope } from "@fortawesome/free-solid-svg-icons"

export const Envelope = (props) => {
  return <FontAwesomeIcon faIcon={faEnvelope} {...props} />
}
